import React from 'react';

const TestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      name: 'Ayşe Kaya',
      role: 'Lise Öğrencisi Velisi',
      content: 'Esin Hanım sayesinde kızım üniversite sınavına çok daha organize ve motivasyonlu hazırlandı. Öğrenci koçluğu gerçekten işe yarıyor!',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/9983e3b28dc13f83d4a2e7ed88f7d748.jpg'
    },
    {
      name: 'Mehmet Demir',
      role: 'Kariyer Değişimi',
      content: 'Mühendislikten eğitime geçiş yaparken Esin Hanım\'ın rehberliği çok değerliydi. Bilimsel yaklaşımı ve deneyimi fark yarattı.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20Turkish%20man%20in%20his%2030s%2C%20confident%20expression%2C%20business%20casual%20attire%2C%20career%20success%20portrait%2C%20modern%20office%20background%2C%20satisfied%20client%20testimonial&width=100&height=100&seq=testimonial-2&orientation=squarish'
    },
    {
      name: 'Zeynep Özkan',
      role: 'Üniversite Öğrencisi',
      content: 'Akademik hedeflerimi netleştirmek ve zaman yönetimi konusunda aldığım destek sayesinde çok daha başarılı oldum.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Young%20Turkish%20university%20student%20woman%2C%20bright%20smile%2C%20academic%20success%2C%20modern%20campus%20background%2C%20confident%20and%20happy%20expression%2C%20natural%20portrait%20lighting&width=100&height=100&seq=testimonial-3&orientation=squarish'
    },
    {
      name: 'Ali Yılmaz',
      role: 'Ebeveyn',
      content: 'Çocuğumla iletişimimiz çok gelişti. Ebeveyn koçluğu aldıktan sonra aile dinamiklerimiz pozitif yönde değişti.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Turkish%20father%20in%20his%2040s%2C%20warm%20paternal%20expression%2C%20family%20man%20portrait%2C%20natural%20lighting%2C%20satisfied%20parent%20testimonial%2C%20modern%20home%20background&width=100&height=100&seq=testimonial-4&orientation=squarish'
    },
    {
      name: 'Fatma Şen',
      role: 'Öğretmen',
      content: 'Meslektaşım olarak Esin Hanım\'ın profesyonelliğine ve ICF standartlarına uygunluğuna şahit oldum. Kesinlikle tavsiye ederim.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20Turkish%20female%20teacher%2C%20confident%20and%20knowledgeable%20expression%2C%20educational%20background%2C%20warm%20professional%20portrait%2C%20natural%20lighting%2C%20colleague%20testimonial&width=100&height=100&seq=testimonial-5&orientation=squarish'
    },
    {
      name: 'Burak Kılıç',
      role: 'Yönetici',
      content: 'Liderlik becerilerimi geliştirmek için aldığım kariyer koçluğu sayesinde iş hayatımda önemli ilerlemeler kaydettim.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Successful%20Turkish%20business%20executive%20man%2C%20leadership%20confidence%2C%20professional%20suit%2C%20corporate%20office%20background%2C%20achievement%20and%20success%20portrait%2C%20modern%20lighting&width=100&height=100&seq=testimonial-6&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Müşteri <span className="text-teal-600">Deneyimleri</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Koçluk sürecinden geçen müşterilerimin deneyimleri ve başarı hikayeleri.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300">
              <div className="flex items-center mb-6">
                <img
                  src={testimonial.image}
                  alt={`${testimonial.name} - Müşteri deneyimi`}
                  className="w-16 h-16 rounded-full object-cover mr-4 object-top"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.content}"
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-teal-600 to-blue-600 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">
              Siz de Başarı Hikayenizi Yazın
            </h3>
            <p className="text-lg mb-6 opacity-90">
              Binlerce kişinin hayatına dokunmuş, kanıtlanmış koçluk metodolojisi ile 
              hedeflerinize ulaşmanın zamanı geldi.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
              <div>
                <div className="text-3xl font-bold">500+</div>
                <div className="text-sm opacity-80">Başarılı Koçluk</div>
              </div>
              <div>
                <div className="text-3xl font-bold">98%</div>
                <div className="text-sm opacity-80">Memnuniyet Oranı</div>
              </div>
              <div>
                <div className="text-3xl font-bold">25+</div>
                <div className="text-sm opacity-80">Yıl Deneyim</div>
              </div>
              <div>
                <div className="text-3xl font-bold">ICF</div>
                <div className="text-sm opacity-80">Akreditasyon</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;